interface LogoProps {
  /** Height of the mark in px (wordmark scales with it). Default 32. */
  size?: number;
  /** Show the "postza" wordmark next to the mark. Default true. */
  showWordmark?: boolean;
  /** Colorway. "light" = for light backgrounds (default), "dark" = for dark surfaces. */
  variant?: "light" | "dark";
  className?: string;
}

/**
 * Postza brand lockup — post-stack mark + coral spark, optional Nunito-900 wordmark.
 * Mirrors postza-media/postza-media-pack/svg/postza-icon.svg (light + dark variants).
 */
export default function Logo({
  size = 32,
  showWordmark = true,
  variant = "light",
  className,
}: LogoProps) {
  const stack = variant === "dark" ? "#8A8CF0" : "#5457D6";
  const inner = variant === "dark" ? "#191B2C" : "#ffffff";
  const spark = variant === "dark" ? "#FF8A6C" : "#F26B4E";
  const word = variant === "dark" ? "#ffffff" : "#1C1E2E";

  return (
    <span
      className={className}
      style={{ display: "inline-flex", alignItems: "center", gap: size * 0.22 }}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 96 96"
        fill="none"
        role="img"
        aria-label="Postza"
      >
        <rect
          x="14"
          y="42"
          width="56"
          height="42"
          rx="10"
          fill={stack}
          opacity="0.22"
        />
        <rect
          x="20"
          y="32"
          width="56"
          height="42"
          rx="10"
          fill={stack}
          opacity="0.5"
        />
        <rect x="26" y="22" width="56" height="42" rx="10" fill={stack} />
        <rect x="36" y="36" width="28" height="6" rx="3" fill={inner} />
        <rect
          x="36"
          y="48"
          width="18"
          height="6"
          rx="3"
          fill={inner}
          opacity="0.7"
        />
        <path
          d="M80 8 C82 16 84 18 92 20 C84 22 82 24 80 32 C78 24 76 22 68 20 C76 18 78 16 80 8 Z"
          fill={spark}
        />
      </svg>
      {showWordmark && (
        <span
          style={{
            fontWeight: 900,
            fontSize: size * 0.82,
            letterSpacing: "-0.015em",
            color: word,
            lineHeight: 1,
          }}
        >
          postza
        </span>
      )}
    </span>
  );
}
